const ROOTS = {
    // AUTH: '/auth',
    AUTH: "",
    // AUTH_DEMO: '/auth-demo',
    DASHBOARD: "/dashboard"
};

// ----------------------------------------------------------------------

export const paths = {
    comingSoon: "/coming-soon",
    //
    page500: "/500",
    page404: "/404",
    page403: "/403",
    page402: "/402",
    //
    // AUTH
    auth: {
        login: `${ ROOTS.AUTH }/login`,
        'new-password': `${ ROOTS.AUTH }/new-password`
    },
    //
    onboarding: "/onboarding",
    // DASHBOARD
    dashboard: {
        root: ROOTS.DASHBOARD,
        //
        transaction: `/transactions`,
        //
        api: {
            root: `/api`,
            //
            key: {
                root: `/api/key`
            }
        },
         shipments: {
            root: `/shipments/create`,
            list: '/shipments/list',
            pickup: `/shipments/#pickups`,
            scan_form: `/shipments/#scan_form`,
            //
            pickup_schedule_usps: `/shipments/schedule_pickup_usps`,
            pickup_schedule_ups: `/shipments/schedule_pickup_ups`,
            scan_form_schedule: `/shipments/schedule_scan_form`,
            quick_rate: `/shipments/quick_rate`,
            //
            create: (id) => id ? `/shipments/create/${ id }` : "/shipments/create",
            create_form: `/shipments/create#form`,
            shipments_view: (id) => `/shipments/${ id }`
        },
        settings: {
            root: `/settings`,
            //
            profile: {
                root: `/settings/profile`
            },
            address_book: {
                root: `/settings/address_book`
            },
            carriers: {
                root: `/settings/carriers`
            }
        },
        //
        blank: `${ ROOTS.DASHBOARD }/blank`
    },
    //
    preview: `/label`,
    //
    // External
    external: {
        orderTemplate: "https://cdn.hihiship.com/assets/file/template/hihiship_order_template.csv",
    }
};
